import { gql, TypedDocumentNode } from 'apollo-angular';

import {
  IFetchUserData,
  IFetchUserEntitiesData,
  IListUserInviteSourcesData,
  ISendPhoneNumberConfirmationData,
} from '@shared/models/auth';
import { USER_PREFERENCE_FRAGMENT } from '@graphql/mutations/user.mutation';

export const ORGANIZATION_FRAGMENT = gql`
  fragment OrganizationFragment on Organization {
    id
    name
    shortName
  }
`;

export const FETCH_CURRENT_USER: TypedDocumentNode<IFetchUserData, {}> = gql`
  ${USER_PREFERENCE_FRAGMENT}
  ${ORGANIZATION_FRAGMENT}
  query self {
    self {
      __typename
      id
      firstName
      surname
      email
      phoneNumber
      roles
      confirmedAt
      isActive
      referralCode
      insertedAt
      submarkets {
        id
        name
        displayName
      }
      preference {
        ...UserPreferenceFragment
      }
      organization {
        ...OrganizationFragment
      }
    }
  }
`;

export const FETCH_CURRENT_USER_ENTITIES: TypedDocumentNode<
  IFetchUserEntitiesData,
  { userId: string }
> = gql`
  query listByUser($userId: ID!) {
    listByUser(userId: $userId) {
      id
      entityId
      fullName
    }
  }
`;

export const REQUEST_PASSWORD_RESET: TypedDocumentNode<
  {},
  { email: string }
> = gql`
  query requestPasswordReset($email: String!) {
    requestPasswordReset(email: $email)
  }
`;

export const SEND_PHONE_NUMBER_CONFIRMATION: TypedDocumentNode<
  ISendPhoneNumberConfirmationData,
  {}
> = gql`
  query sendPhoneNumberConfirmation {
    sendPhoneNumberConfirmation
  }
`;

export const LIST_USER_INVITE_SOURCES: TypedDocumentNode<IListUserInviteSourcesData> = gql`
  query listUserInviteSources {
    listUserInviteSources {
      id
      name
    }
  }
`;
